import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import type { NameAndType, TsCodeType, TsTypeType } from '../types.js'
import { ValidationRule } from '../data/validation-rule.js'
import type { MandatoryType } from '../data/validation-rule.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { TypeReference } from '../data/type-reference.js'
import { BoVisitor } from './bo-visitor.js'
import type { Scope } from 'ts-morph'

@jsonClass('EntityProperty')
export class EntityProperty implements NameAndType {
	@jsonProperty(String) uuid!: string
	@jsonProperty(String) name!: string
	@jsonProperty(String) type: TsTypeType = 'string'
	@jsonArrayProperty(ValidationRule) validationRules: ValidationRule[] = []
	@jsonProperty(Number) mandatoryLevel: MandatoryType = 0 // 0=not mandatory
	@jsonProperty(Boolean) isStatic: boolean = false
	@jsonProperty(Boolean) isOfInterest: boolean = true
	@jsonProperty(String) defaultExpression: TsCodeType = ''
	@jsonProperty(Number) maxLen: number = 0
	@jsonProperty(String) mandatoryExpression?: TsCodeType
	@jsonProperty(String) scope?: Scope
	@jsonProperty(Boolean) isSearchableByDefault: boolean = false

	questionToken: boolean = false
	exclamationToken: boolean = false

	constructor(init?: Partial<EntityProperty>) {
		assignCommonProperties(this, init)
	}

	visit(visitor: BoVisitor, pathPrefix: (string | number)[]): void {
		// super.visit(visitor, pathPrefix)
		visitor.visitTsCode(
			this.defaultExpression,
			this,
			'property',
			[...pathPrefix, 'defaultExpression'],
			(newCode) => (this.defaultExpression = newCode),
		)
		visitor.visitTsCode(
			this.type,
			this,
			'type',
			[...pathPrefix, 'type'],
			(newType) => (this.type = newType),
		)
		this.validationRules.forEach((rule, idx) =>
			rule.visit(visitor, [...pathPrefix, 'validationRules', idx]),
		)
	}
}
